import React, { useEffect, useState } from 'react';
import { Row, Col, Spin } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ActionPlanInfo } from './ActionPlanInfo';
import { ExtractActionPlansFormItem } from './ExtractActionPlansFormItem';
import { useHandleActionPlanExtraction } from '@/components/Settings/DataExtraction/Content/hooks/useHandleActionPlanExtraction';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { REPORT_TYPES } from '@/utils/constants';
import { GhostButton } from '@/components/ui/Button';

interface ActionPlanProps {
	reportIds?: string[];
	reportType?: string;
	formattedName?: string;
}

export function ActionPlan({ reportType = '', formattedName = '' }: Readonly<ActionPlanProps>) {
	const [showDetails, setShowDetails] = useState<boolean>(false);
	const { dataExtractionReport, selectedReportsCount } = useDataExtractionReport();
	const dataExtractionId = dataExtractionReport?.id;
	const reportsSelectedCount = selectedReportsCount || null;
	const isBeraReport = dataExtractionReport?.custom_report?.report_type === REPORT_TYPES.BERA;
	const hasCustomReport = dataExtractionReport?.custom_report_id;

	const { currentActionPlan, refetch, isLoading } = useHandleActionPlanExtraction(
		isBeraReport ? '' : reportType,
		dataExtractionId
	);

	async function handleOnClick(): Promise<void> {
		setShowDetails(true);
		await refetch();
	}

	useEffect((): void => {
		if (!reportsSelectedCount || isBeraReport) {
			setShowDetails(false);
		}
	}, [reportsSelectedCount, dataExtractionReport?.custom_report_id]);

	return (
		<Row gutter={[0, 32]}>
			{hasCustomReport && (
				<Col>
					<GhostButton onClick={handleOnClick} disabled={!reportsSelectedCount || isBeraReport}>
						{I18n.get('Review action plans')}
					</GhostButton>
				</Col>
			)}
			{showDetails && reportsSelectedCount && (
				<Col span={24}>
					<Spin spinning={isLoading}>
						<Row gutter={[0, 32]}>
							<Col span={24}>
								<ActionPlanInfo
									evaluations={reportsSelectedCount}
									reportName={formattedName}
									actionPlansCount={currentActionPlan?.total_action_plans}
								/>
							</Col>
							{currentActionPlan?.total_action_plans > 0 && (
								<Col span={24}>
									<ExtractActionPlansFormItem />
								</Col>
							)}
						</Row>
					</Spin>
				</Col>
			)}
		</Row>
	);
}
